import { Injectable, ComponentFactoryResolver, ApplicationRef, Injector, ViewContainerRef, ElementRef, Component } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ApiUrlHelper } from '../api-url-helper';
import { HttpClientHelper } from '../http-helper';

@Injectable({
  providedIn:'root'
})

export class FooterService {
    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _httpClientHelper: HttpClientHelper,)
    {

    }
    private cached = null;
    getCoBusiness(region): Observable<any[]> {
        if(this.cached ==null)
        {
          const apiURL = this._apiUrlHelper.urlBuilder(
            'get-co-business',
            {
              region: region,
              page: 1,
              size: 8,
            }
          );
          this.cached =  this._httpClientHelper.getWithCache(apiURL).pipe(map(res => {
              return res[0];
            })).pipe(shareReplay({
              bufferSize:1,
              refCount:true
            }));
      
        }
      
        return this.cached;
      }
}
